import React, { useEffect, useState } from 'react';
import CheckNameComp from '@components/checkName';
import { APP_CONFIG } from '@constants';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  setSeat,
  removeSeat,
  clearCart,
  removePaymentCheck,
  enableStartOverBtn,
  setCountrycode
} from '@reducers/orders';
import {
  setInActivityStatus
} from '@reducers/oauth';
import {
  clearAuthResponse
} from '@reducers/payment';
import { setNotification } from '@reducers/notification';
import { checkOpen } from '@reducers/checks';
import Loader from '@components/common/Loader/newLoaderModal';
import EventEmitter from '@utility/eventSubscribers';
import { getObjectValue, urlSearchParams } from '@utility/utills';
import { COUNTRY_CODE } from '@constants/index';

const CheckNameContainer = (props) => {

  // Props Destructuring

  const {deviceInfo, auth, enableStartOverBtn, removeSeat, clearCart, clearAuthResponse, removePaymentCheck, setCountrycode, checkOpen, 
   setSeat, setNotification, isHeight, themeProperties } = props;

  // State Management

  const phoneNumberRequired = getObjectValue(() => deviceInfo.deviceGroup.inputFields.phoneNumberRequired, false);
  const orderType = urlSearchParams('orderType');
  const defaultCountryCode = getObjectValue(() => COUNTRY_CODE[auth.country].dialCode, '1');
  const [phoneNumberMaxLength, setPhoneNumberMaxLength] = useState(getObjectValue(() => COUNTRY_CODE[auth.country].maxLength, 15));
  const [countryCode, setCountryCode] = useState(defaultCountryCode);

  // React Hooks

  useEffect(() => {
    if (window.ReactNativeWebView) {
      EventEmitter.enableSideBar(false);
    }
    enableStartOverBtn(true);
    removeSeat();
    clearCart();
    clearAuthResponse();
    removePaymentCheck();
  }, []);

  // Methods

  const itemsFilter = (array) => {
    return array.filter((e) => e.pending).map((e) => {
      return {
        ...e,
        ...JSON.parse(e.orderJson)
      };
    });
  };

  const handleBack = () => {
    props.history.replace(`${APP_CONFIG.BASE_URL}/kiosk`);
  };

  const handleCountryCodeChange = (e) => {
    setPhoneNumberMaxLength(getObjectValue(() => COUNTRY_CODE[e.id].maxLength, 15));
    setCountrycode(e.id);
    setCountryCode(e.id);
  };

  const submitTab = (tabName) => {
    const dataToSend = {
      deviceId: deviceInfo.deviceId,
      employeeId: Number(JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      storeId: deviceInfo.storeId,
      phoneNumber: tabName.phoneNumber,
      countryCode,
      stationId: null,
      toGo: orderType === 'dineIn' ? !orderType === 'dineIn' : (orderType === 'toGo' || getObjectValue(() => deviceInfo.deviceGroup.orderTypes.toGo, false)),
      employeeCard: getObjectValue(() => JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard, null),
      name: tabName.checkName,
      stationGroupId: null,
      isTab: true,
      pickupTime: null,
      guestName: null,
      guestCount: 1,
      sourceType: 1,
      delivery: false,
      speedOrder: false,
    };
    checkOpen(dataToSend).then((val) => {
      setSeat({ ...val, pendingItems: itemsFilter((val.orders[0].items) || []) });
      enableStartOverBtn(true);
      props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/kiosk/orders` }));
    }).catch((err) => {
      setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  // HTML CSS Code

  return (
    <>
      {props.loading && <Loader />}
      <CheckNameComp
        inputFields={deviceInfo.deviceGroup.inputFields}
        submitTab={submitTab}
        isHeight={isHeight}
        themeProperties={themeProperties}
        handleBack={handleBack}
        countryCode={countryCode}
        phoneNumberMaxLength={phoneNumberMaxLength}
        handleCountryCodeChange={handleCountryCodeChange}
        phoneNumberRequired={phoneNumberRequired}
      />
    </>
  );
};

// Redux Part

const mapStateToProps = ({
  orders,
  oauth,
  checks,
  theme
}) => ({
  seat: orders.seats || orders.loading,
  loading: checks.loading,
  auth: oauth.authInfo,
  deviceInfo: oauth.deviceInformation,
  userInfo: oauth.loggedInUserData,
  themeProperties: theme.themeProperties,
  isHeight: orders.isHeight
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  checkOpen,
  setSeat,
  setNotification,
  clearCart,
  removeSeat,
  setInActivityStatus,
  clearAuthResponse,
  setCountrycode,
  removePaymentCheck,
  enableStartOverBtn
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckNameContainer);
